/* Viretta v2 – »Få besked, når 5-Ply kan bestilles« forms → Klaviyo (owner 9 Oct: use Klaviyo, not Shopify customer forms).
   Viretta's Klaviyo account (company Wfe5y7, the same one the live site loads):
   - every signup sends the event »5-Ply venteliste« (metric) with source/page/pieces/surface – build the segment + launch flow
     on that metric in Klaviyo; it does NOT subscribe anyone to marketing.
   - only when the shopper ticks »Send mig også nyhedsbrevet« the profile is subscribed to the newsletter list SzGKE7
     (the list the live header newsletter uses).
   Markup: <form data-v2-kl data-source="…"> with input[name=email], optional input[data-v2-nl], [data-v2-klok], [data-v2-klerr]. */
(function () {
  if (window.V2Klaviyo) return; window.V2Klaviyo = true;
  var CO = 'Wfe5y7', NL = 'SzGKE7', REV = '2025-01-15';
  var base = 'https://a.klaviyo.com/client/';
  function post(path, body) {
    return fetch(base + path + '?company_id=' + CO, { method: 'POST', headers: { 'Content-Type': 'application/json', revision: REV }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw new Error(path + ' ' + r.status); return r; });
  }
  function extra(f) {
    var p = {};
    var sets = f.closest('[data-v2-sets]');
    if (sets) {
      p.pieces = [].map.call(sets.querySelectorAll('[data-v2-5pick].is-on'), function (b) { return b.textContent.replace(/\s+/g, ' ').trim(); }).join(' + ');
      p.surface = sets.classList.contains('is-ti') ? 'Titanium Plasma' : 'Rustfrit stål';
    }
    return p;
  }
  document.addEventListener('submit', function (e) {
    var f = e.target; if (!f.matches || !f.matches('[data-v2-kl]')) return;
    e.preventDefault();
    var input = f.querySelector('input[name="email"]'), err = f.querySelector('[data-v2-klerr]'), ok = f.querySelector('[data-v2-klok]');
    var btn = f.querySelector('button[type="submit"]'), nl = f.querySelector('[data-v2-nl]');
    var email = (input.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { if (err) err.hidden = false; input.focus(); return; }
    if (err) err.hidden = true;
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    var props = Object.assign({ source: f.getAttribute('data-source') || 'v2', page: location.pathname, newsletter: !!(nl && nl.checked) }, extra(f));
    var jobs = [post('events/', { data: { type: 'event', attributes: {
      properties: props,
      metric: { data: { type: 'metric', attributes: { name: '5-Ply venteliste' } } },
      profile: { data: { type: 'profile', attributes: { email: email } } } } } })];
    if (nl && nl.checked) jobs.push(post('subscriptions/', { data: { type: 'subscription', attributes: { profile: { data: { type: 'profile', attributes: { email: email } } } },
      relationships: { list: { data: { type: 'list', id: NL } } } } }));
    Promise.all(jobs).then(function () {
      [].forEach.call(f.children, function (c) { if (c !== ok) c.hidden = true; });
      if (ok) { ok.hidden = false; ok.focus && ok.setAttribute('tabindex', '-1'); ok.focus && ok.focus(); }
    }).catch(function () {
      if (err) { err.textContent = 'Det gik ikke – prøv igen om lidt.'; err.hidden = false; }
    }).then(function () { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); } });
  });
})();
